import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-ink text-rice/80 mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-5">
            <span className="w-10 h-10 bg-cinnabar text-rice flex items-center justify-center font-serif text-2xl">中</span>
            <span className="font-serif text-2xl text-rice">CCLPT</span>
          </div>
          <p className="text-sm max-w-md leading-relaxed text-rice/60">
            The Center for Chinese Language Pedagogy and Training — cultivating Mandarin proficiency
            from beginner to advanced (aligned to new HSK 3.0) and training India's next generation
            of Chinese language teachers.
          </p>
        </div>
        <div>
          <p className="label text-gold mb-4">Explore</p>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/courses" className="hover:text-rice transition-colors">Language Courses</Link></li>
            <li><Link to="/teacher-training" className="hover:text-rice transition-colors">Teacher Training</Link></li>
            <li><Link to="/exam-prep" className="hover:text-rice transition-colors">Exam Preparation</Link></li>
            <li><Link to="/consultation" className="hover:text-rice transition-colors">Study in China</Link></li>
            <li><Link to="/about" className="hover:text-rice transition-colors">About Us</Link></li>
          </ul>
        </div>
        <div>
          <p className="label text-gold mb-4">Contact</p>
          <ul className="space-y-2.5 text-sm text-rice/60">
            <li>info@cclpt.com</li>
            <li>+91 98765 43210</li>
            <li>New Delhi, India</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-rice/40">
          <span>© {new Date().getFullYear()} Center for Chinese Language Pedagogy and Training</span>
          <span className="font-mono">学而不厌，诲人不倦 · Learn without weariness, teach without fatigue</span>
        </div>
      </div>
    </footer>
  );
}
